import { IMetricItemResponseData } from "types/api/dashboard";
import { IMetrics } from "types/dashboard";

export const formatMetricsItem = (data: IMetricItemResponseData): IMetrics => {
  return {
    duringPeriod: data.periodAmount,
    total: data.totalAmount,
  };
};
